<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
  @font-face {
    font-family: 'gorditabold';
    src: url('../public/fonts/gordita-bold-webfont.woff2') format('woff2'),
          url('../public/fonts/gordita-bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'gorditamedium';
    src: url('../public/fonts/gordita-medium-webfont.woff2') format('woff2'),
          url('../public/fonts/gordita-medium-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'gorditaregular';
    src: url('../public/fonts/gordita-regular-webfont.woff2') format('woff2'),
          url('../public/fonts/gordita-regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'gorditasemibold';
    src: url('../public/fonts/gordita-semibold-webfont.woff2') format('woff2'),
          url('../public/fonts/gordita-semibold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  html, body, h1, label, p, sup, input {
    color: #2e2e2e;
  }

  h1, h2, h3, h4 {
    font-family: 'gorditabold';
  }

  h1 {
    font-size: 40px;
    padding-top: 28px;
    padding-left: 10px;
  }

  @media all and (min-width: 600px) {
    h1 {
      font-size: 52px;
    }
  }

  h2 {
    font-size: 32px;
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 16px;
  }

  ul, li {
    font-family: 'gorditaregular';
    color: #2e2e2e;
  }

  a,
  .link {
    cursor: pointer;
    color: #2e2e2e;
    font-family: 'gorditabold';
    text-decoration: underline;

    &.no-underline {
      text-decoration: none;
    }

    &:hover,
    &:focus {
      color: #2e2e2e;

    }
  }

  label,
  p {
    font-family: 'gorditaregular';
  }

  label {
    margin-bottom: 8px;
  }

  .text-red {
    color: #ff3a12!important;
  }

  .eqrx-radio {
    position: relative;
    top: 3px;
    appearance: none;
    -webkit-appearance: none;
    border-radius: 50%;
    background: #fff;
    border: 3px solid #FFF;
    box-shadow: 0 0 0 1px #ff3a12;
    width: 15px;
    height: 15px;
    margin-bottom: 0;
  }
  .eqrx-radio:checked {
    background: #ff3a12;
  }

  .button {
    background-color: #ff3a12;
    color: #FFF;

    &.rounded {
      border-radius: 30px;
    }

    &.ghost {
      background-color: transparent;
      border: 1px solid #2e2e2e;
      border-radius: 30px;
      color: #2e2e2e;

      &:hover,
      &:focus {
        background-color: transparent;
        text-decoration: underline;
      }
    }

    &:hover,
    &:focus {
      background-color: darken(#ff3a12, 20%);
    }
  }

  sup {
    top: 2px;
    font-size: 15px;
    color: #ff3a12;
    margin-right: 2px;
  }

  form.contact-form input.eqrx {
    border: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    border-left: #ff3a12 solid 4px;
    background-color: #e9e9e9;
  }

  .bg-lg {
    background-color: #f4f4f4;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 230px;
      height: 230px;
      background-image: url('../public/img/circle-graphic.svg');
      background-repeat: no-repeat;
      background-position: 100px -65px;
    }
  }

  .white-space {
    display: block;
    background-color: #FFF;
    height: 30px;
  }

  .logo {
    width: 100px;
    padding: 10px;
  }

  footer {
    position: relative;
    padding-top: 100px;
    border-bottom: 50px solid #2e2e2e;

    .red-ball {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 200px;
      background-image: url('../public/img/red-circle.svg');
      background-position: -50px 80px;
      background-repeat: no-repeat;
    }
  }

  .code {
    font-family: 'gorditaregular';
    font-size: 16px;
    margin-bottom: 0;
  }

  .date {
    font-family: 'gorditaregular';
    font-size: 12px;
  }
</style>
